(function microsite() {
    function initRemoteLogin(Ctor, options, submitId) {
        if (typeof Ctor !== 'function') return null;
        const instance = new Ctor(options);
        const submit = document.getElementById(submitId);
        if (submit) submit.disabled = false;
        return instance;
    }

    function init() {
        const dropdown = document.querySelector('.login-dropdown-microsite');
        if (!dropdown) return;

        const tabs = dropdown.querySelectorAll('.login-dropdown-tab');
        const panes = dropdown.querySelectorAll('.login-dropdown-pane');
        const roSelector = document.getElementById('fiservROSelector');
        const boSelector = document.getElementById('fiservBOSelector');

        function setProduct(target) {
            const isBusiness = target === 'business';
            if (roSelector) roSelector.checked = !isBusiness;
            if (boSelector) boSelector.checked = isBusiness;
        }

        tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                const target = tab.getAttribute('data-fsb-tab');
                tabs.forEach((t) => {
                    const active = t === tab;
                    t.classList.toggle('is-active', active);
                    t.setAttribute('aria-selected', active ? 'true' : 'false');
                });
                panes.forEach((p) => {
                    const match = p.getAttribute('data-fsb-pane') === target;
                    p.classList.toggle('is-active', match);
                    if (match) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
                });
                setProduct(target);
            });
        });

        setProduct('personal');

        initRemoteLogin(window.PBI && window.PBI.RemoteLogin, {
            themeNumber: '1',
            applicationPath: 'https://web10.secureinternetbank.com/PBI_PBI1151',
            formId: 'pbi-form',
            passwordId: 'pbi-password',
            routingTransit: '061206814',
            usernameId: 'pbi-username'
        }, 'pbi-submit');

        initRemoteLogin(window.EBC && window.EBC.RemoteLogin, {
            applicationPath: 'https://web10.secureinternetbank.com/EBC_EBC1151',
            formId: 'ebc-form',
            passwordId: 'ebc-password',
            routingTransit: '061206814',
            profileNumber: 55,
            usernameId: 'ebc-username'
        }, 'ebcsubmit');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
